import { render, staticRenderFns } from "./DsfExamRecord.vue?vue&type=template&id=5f621f50&"
import script from "./DsfExamRecord.vue?vue&type=script&lang=js&"
export * from "./DsfExamRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f621f50')) {
      api.createRecord('5f621f50', component.options)
    } else {
      api.reload('5f621f50', component.options)
    }
    module.hot.accept("./DsfExamRecord.vue?vue&type=template&id=5f621f50&", function () {
      api.rerender('5f621f50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/views/DsfExamRecord.vue"
export default component.exports